



























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop({ default: [] })
  filters!: Array<{ value: string, short: string }>

  @Prop({ required: true })
  R!: string

  get _R() {
    return this.R
  }
  set _R(v: string) {
    this.$emit('update:R', v)
  }

  @Prop({ required: true })
  G!: string
  get _G() {
    return this.G
  }
  set _G(v: string) {
    this.$emit('update:G', v)
  }

  @Prop({ required: true })
  B!: string
  get _B() {
    return this.B
  }
  set _B(v: string) {
    this.$emit('update:B', v)
  }

  singleFilter(filter: string) {
    this.$emit('update:R', filter)
    this.$emit('update:G', filter)
    this.$emit('update:B', filter)
  }
}
